// Lightweight JWT helpers and auto-logout scheduler

let logoutTimerId = null;

export function getToken() {
  return localStorage.getItem('token');
}

export function clearToken() {
  localStorage.removeItem('token');
}

export function decodeJwtPayload(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1]));
    return payload || null;
  } catch (_e) {
    return null;
  }
}

export function getTokenExpiryMs(token) {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== 'number') return null;
  return payload.exp * 1000; // exp is in seconds
}

export function isTokenExpired(token) {
  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) return false;
  return Date.now() >= expiryMs;
}

export function logoutAndRedirect() {
  clearToken();
  try {
    // Avoid multiple timers lingering
    if (logoutTimerId) {
      clearTimeout(logoutTimerId);
      logoutTimerId = null;
    }
  } catch (_e) {}
  // Force navigation to login
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}

export function scheduleAutoLogout(token) {
  // Clear any existing timer
  if (logoutTimerId) {
    clearTimeout(logoutTimerId);
    logoutTimerId = null;
  }

  if (!token) return;

  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) return;

  const msUntilExpiry = Math.max(0, expiryMs - Date.now());
  logoutTimerId = setTimeout(() => {
    logoutAndRedirect();
  }, msUntilExpiry);
}

export function ensureTokenValidityOrLogout() {
  const token = getToken();
  if (!token) return false;
  if (isTokenExpired(token)) {
    logoutAndRedirect();
    return false;
  }
  // Keep the scheduler in sync in case of refresh
  scheduleAutoLogout(token);
  return true;
}










